import {router, routerFuns} from "sw-hic";

// routerFuns.init({
//   patient: () => import("@/components/patient"),
//   deposit: () => import("@/components/deposit"),
//   bed: () => import("@/components/bed"),
//   settle: () => import("@/components/settle"),
// })

routerFuns.init([
  {
    path: "/patient",
    name: "patient",
    component: () => import("@/components/patient"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/deposit",
    name: "deposit",
    component: () => import("@/components/deposit"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bed",
    name: "bed",
    component: () => import("@/components/bed"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settle",
    name: "settle",
    component: () => import("@/components/settle"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/nurse",
    name: "nurse",
    component: () => import("@/components/nurse"),
    meta: {
      requiresAuth: true,
    },
  },
]);


export default router;